(function() {
  const form = document.querySelector('.product-hero__form');
  if (!form) return;

  const EDIT_PARAM = 'edit';
  const searchParams = new URLSearchParams(window.location.search);
  const editItemKey = searchParams.get(EDIT_PARAM);

  const ctaButton = form.querySelector('.product-hero__cta');
  const stickyCtaButton = document.querySelector('.product-hero__sticky-cta');
  const priceEls = document.querySelectorAll('[data-product-price], [data-product-sticky-price]');
  const hiddenIdInput = form.querySelector('input[name="id"]');
  const sizeUnavailableNote = form.querySelector('[data-size-unavailable-note]');
  const combinationUnavailableNote = form.querySelector('[data-combination-unavailable-note]');

  // TASK TL19 — window.FSBVariantAvailability (assets/variant-availability.js) is the one
  // place that decides whether an option value is purchasable; see that file for why.
  const availability = window.FSBVariantAvailability;

  const variantsScript = document.querySelector('[data-product-variants]');
  const moneyFormatScript = document.querySelector('[data-money-format]');

  if (!variantsScript || !moneyFormatScript || !hiddenIdInput) return;

  const variants = JSON.parse(variantsScript.textContent);
  const moneyFormat = JSON.parse(moneyFormatScript.textContent);

  const radioInputs = form.querySelectorAll('input[type="radio"]');
  const labels = form.querySelectorAll('label');
  const submitButtons = [ctaButton, stickyCtaButton].filter(Boolean);
  let isEditSubmitting = false;

  function setSubmittingState(isSubmitting) {
    submitButtons.forEach((btn) => {
      btn.disabled = isSubmitting;
      btn.setAttribute('aria-disabled', isSubmitting ? 'true' : 'false');
      btn.classList.toggle('is-disabled', isSubmitting);
    });
  }

  async function fetchJson(url, options) {
    const res = await fetch(url, {
      headers: { Accept: 'application/json' },
      ...options
    });

    if (!res.ok) {
      throw new Error(`Request failed: ${url}`);
    }

    return res.json();
  }

  async function fetchCart() {
    return fetchJson('/cart.js');
  }

  async function changeItemQuantity(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity })
    });

    if (!res.ok) {
      throw new Error('Cart change failed');
    }
  }

  async function removeItems(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!res.ok) {
      throw new Error('Cart update failed');
    }
  }

  async function addFormItem() {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: new FormData(form)
    });

    if (!res.ok) {
      throw new Error('Add to cart failed');
    }

    return res.json();
  }

  async function addItemsBatch(items) {
    if (!items.length) return;

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      throw new Error('Batch add failed');
    }
  }

  function submitNormally() {
    HTMLFormElement.prototype.submit.call(form);
  }

  function getExtraItems(cart, parentKey) {
    return (cart.items || []).filter((item) => item.properties?._parent_key === parentKey);
  }

  function buildExtraAddPayload(extras, nextParentKey) {
    return extras.map((extra) => ({
      id: extra.variant_id,
      quantity: extra.quantity,
      properties: {
        ...(extra.properties || {}),
        _parent_key: nextParentKey
      }
    }));
  }

  function formatPrice(price) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(price, moneyFormat);
    }
    const dollars = (price / 100).toFixed(2);
    return '$' + dollars;
  }

  function getSelectedOptions() {
    const selected = [];

    radioInputs.forEach(radio => {
      if (radio.checked) {
        const index = parseInt(radio.dataset.optionIndex, 10);
        selected[index] = radio.value;
      }
    });

    return selected;
  }

  function findVariant(selected) {
    return availability.findVariant(variants, selected);
  }

  function updatePrice(variant) {
    if (!priceEls.length) return;

    const newPrice = formatPrice(variant.price);

    priceEls.forEach(el => {
      const hasFrom = el.textContent.includes('From');
      el.textContent = hasFrom ? `From ${newPrice}` : newPrice;
    });
  }

  function updateCTA(isAvailable) {
    const ctaButtons = [ctaButton, stickyCtaButton].filter(Boolean);

    if (combinationUnavailableNote) {
      combinationUnavailableNote.hidden = isAvailable;
    }

    if (!ctaButtons.length) return;

    ctaButtons.forEach(btn => {
      btn.disabled = !isAvailable;

      if (isAvailable) {
        btn.classList.remove('is-disabled');
        btn.setAttribute('aria-disabled', 'false');
      } else {
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function updateCardSelection() {
    labels.forEach(label => {
      const radio = label.querySelector('input[type="radio"]');

      if (radio && radio.checked) {
        label.classList.add('is-selected');
      } else {
        label.classList.remove('is-selected');
      }
    });
  }

  // TASK TL19 (DEF-70/DEF-60) — which sizes are offered for the selected book type is
  // derived from the actual variant data (option values + `available`) via
  // window.FSBVariantAvailability, not a hand-written "Saddle stitch only comes in 8x8"
  // rule. The cart Edit modal (assets/cart-edit-modal.js) reads the same source, so the
  // two can never disagree about which combinations exist.
  function updateDependentOptions() {
    const selected = getSelectedOptions();
    let unavailableForBookType = false;

    const sizeRadios = form.querySelectorAll('input[type="radio"][data-option-index="1"]');
    const availableSizeRadios = [];

    sizeRadios.forEach(radio => {
      const sizeLabel = radio.closest('label');
      const isAvailable = availability.isOptionValueAvailable(variants, 1, radio.value, selected);

      radio.disabled = !isAvailable;

      if (sizeLabel) {
        sizeLabel.classList.toggle('is-disabled', !isAvailable);
        sizeLabel.style.pointerEvents = isAvailable ? '' : 'none';
        sizeLabel.title = isAvailable ? '' : `Not available in ${selected[0] || 'this cover type'}`;
      }

      if (isAvailable) {
        availableSizeRadios.push(radio);
      } else {
        unavailableForBookType = true;
        if (radio.checked) {
          radio.checked = false;
        }
      }
    });

    // If the previously checked size just got disabled, fall back to the first size
    // that is still available for the newly selected book type.
    if (!sizeRadios.length) {
      // no size option on this product — nothing to reconcile
    } else if (!Array.from(sizeRadios).some(r => r.checked) && availableSizeRadios.length) {
      availableSizeRadios[0].checked = true;
    }

    if (sizeUnavailableNote) {
      sizeUnavailableNote.hidden = !unavailableForBookType;
      sizeUnavailableNote.textContent = unavailableForBookType
        ? `Not all sizes are available in ${selected[0] || 'this cover type'}.`
        : '';
    }
  }

  function handleChange() {
    updateDependentOptions();

    const selected = getSelectedOptions();
    const variant = findVariant(selected);

    if (variant) {
      hiddenIdInput.value = variant.id;
      document.dispatchEvent(new CustomEvent('product-hero:variant-change', {
        detail: { variantId: variant.id }
      }));
      updatePrice(variant);
      updateCTA(variant.available);
    } else {
      updateCTA(false);
    }

    updateCardSelection();
  }

  [ctaButton, stickyCtaButton].filter(Boolean).forEach(btn => {
    btn.addEventListener('click', function(e) {
      if (btn.classList.contains('is-disabled')) {
        e.preventDefault();
      }
    });
  });

  radioInputs.forEach(radio => {
    radio.addEventListener('change', handleChange);
  });

  /**
   * UNREACHABLE SINCE 2026-09-15, and left in place deliberately rather than deleted.
   *
   * This handler runs only when the form actually submits. The CTA's click is now always
   * intercepted by `product-photo-upload-modal.js` (`event.preventDefault()` with no
   * conditional before it), so the form never submits from the button, and nothing in the
   * repository builds the `?edit=` URL that `editItemKey` reads.
   *
   * NOT DELETED HERE because removing it means judging a dozen helpers above
   * (`addFormItem`, `changeItemQuantity`, `removeItems`, `addItemsBatch`, `getExtraItems`,
   * `buildExtraAddPayload`, `submitNormally`, `fetchCart`) for other callers, which is a
   * separate change from closing the hole. Closing the hole was the urgent half.
   *
   * ⚠️ IT IS ALSO BROKEN, so do not revive it as-is: `addFormItem` re-adds the line from
   * `new FormData(form)`, and the product form carries ZERO `properties[...]` inputs
   * (`sections/product-hero.liquid`). A line re-added through it loses the child's name,
   * age, photo and its `_personalization_id`. Any future edit flow has to carry those.
   */
  form.addEventListener('submit', async function(e) {
    if (!editItemKey || isEditSubmitting) return;

    e.preventDefault();
    isEditSubmitting = true;
    setSubmittingState(true);

    let originalItem = null;
    let originalExtras = [];
    let addedItem = null;

    try {
      const cart = await fetchCart();
      originalItem = (cart.items || []).find((item) => item.key === editItemKey);

      if (!originalItem) {
        isEditSubmitting = false;
        setSubmittingState(false);
        submitNormally();
        return;
      }

      originalExtras = getExtraItems(cart, editItemKey);

      await changeItemQuantity(editItemKey, 0);

      addedItem = await addFormItem();

      if (originalExtras.length) {
        await addItemsBatch(buildExtraAddPayload(originalExtras, addedItem.key));
        await removeItems(
          Object.fromEntries(originalExtras.map((item) => [item.key, 0]))
        );
      }

      window.location.href = '/cart';
    } catch (error) {
      try {
        if (addedItem?.key) {
          await changeItemQuantity(addedItem.key, 0);
        }

        if (originalItem) {
          await addItemsBatch([{
            id: originalItem.variant_id,
            quantity: originalItem.quantity,
            properties: originalItem.properties || {}
          }]);
        }
      } catch (rollbackError) {
        console.error('[product-hero] Edit cart rollback failed', rollbackError);
      }

      console.error('[product-hero] Edit cart flow failed', error);
      setSubmittingState(false);
      isEditSubmitting = false;
    }
  });

  handleChange();
})();

(function () {
  var stickyBar = document.querySelector('.product-hero__sticky');
  var formatSelector = document.querySelector('.product-hero__book-type-cards');
  if (!stickyBar || !formatSelector) return;
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      stickyBar.classList.toggle('is-hidden-for-selector', entry.isIntersecting);
    });
  }, { threshold: 0 });

  observer.observe(formatSelector);
})();
